import { useEffect, useState } from 'react';
import { BaxterDog } from './BaxterDog';
import { WORDS, nextIndex } from './working';

export function Thinking({ startedAt }: { startedAt: number }) {
  const [word, setWord] = useState(0);
  const [elapsed, setElapsed] = useState(() => Math.floor((Date.now() - startedAt) / 1000));
  useEffect(() => {
    setWord(0);
    let current = 0;
    setElapsed(Math.floor((Date.now() - startedAt) / 1000));
    let timer: ReturnType<typeof setTimeout>;
    const advance = () => {
      timer = setTimeout(() => { current = nextIndex(current); setWord(current); advance(); }, 4400 + Math.random() * 1400);
    };
    advance();
    const clock = setInterval(() => setElapsed(Math.floor((Date.now() - startedAt) / 1000)), 250);
    return () => { clearTimeout(timer); clearInterval(clock); };
  }, [startedAt]);
  const activity = WORDS[word];
  return <div className="baxter-working-status flex flex-wrap items-center gap-1.5 py-1 text-xs text-muted-foreground" role="status" aria-label="Baxter is working. Press Escape to interrupt.">
    <BaxterDog activity={activity} />
    <span aria-hidden className="baxter-working relative inline-block w-[10ch] overflow-hidden">
      {activity}
      <span className="baxter-working-highlight absolute left-0 top-0 w-max font-semibold text-foreground">{activity}</span>
    </span>
    <span aria-hidden className="tabular-nums">({elapsed}s · esc to interrupt)</span>
  </div>;
}
